// src/hooks/useKeycloak.js
import Keycloak from 'keycloak-js';
import { useEffect, useState } from 'react';

const useKeycloak = () => {
  const [keycloak, setKeycloak] = useState<Keycloak | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeKeycloak = () => {
      if (typeof window !== 'undefined') {
        const keycloakInstance = new Keycloak({
          url: process.env.GATSBY_KEYCLOAK_BASE_URL,
          realm: process.env.GATSBY_KEYCLOAK_REALM,
          clientId: process.env.GATSBY_KEYCLOAK_CLIENT_ID,
        });

        setKeycloak(keycloakInstance);
        setLoading(false);
      }
    };

    initializeKeycloak();
  }, []);

  return { keycloak, loading };
};

export default useKeycloak;
